import { SELL_CAR } from 'site-modules/editorial/constants/slugs';

export const WHAT_IS_RELATIONSHIP_BETWEEN_EDMUNDS_AND_CARMAX = {
  question: 'What is the relationship between Edmunds and CarMax?',
  answer: [
    'Since June 2021, Edmunds has been a wholly owned subsidiary of CarMax, Inc.',
    'To learn more about the relationship between Edmunds and CarMax, see our <a href="/about/visitor-agreement.html">Visitor Agreement</a>.',
  ],
};

export function getSellMyCarInStateFaqContent(stateName) {
  return [
    {
      question: `What is needed to sell a car in ${stateName}?`,
      answer: `You'll need the following items to sell a car in ${stateName}: the vehicle title, registration, your identification, car keys and account information if you're still paying it off. This is just a quick overview, so make sure to double-check with the person you're selling it to.`,
    },
    {
      question: `How do I sell my car in ${stateName}?`,
      answer: `You sell your car in ${stateName} by first determining its market value, getting an offer and taking it to a dealership to conclude the sale. To sell your car quickly, you can appraise it and get an offer on Edmunds. If you're selling it privately, you'll need to take out a classified ad and wait for potential buyers to reach out to you.`,
    },
    {
      question: `Where is the best place to sell a car privately in ${stateName}?`,
      answer: `The best place to sell a car privately in ${stateName} is one that offers a nice balance of safety, convenience and selling price. We've had some success with Autotrader and CarGurus, but note that it might take a while before you get paid. If you're looking for a faster option, take a look at the Edmunds instant offer.`,
    },
    {
      question: `Which is the best site to sell my car in ${stateName}?`,
      answer: `The best site to sell your car in ${stateName} is the one that strikes a balance between convenience and the money you put in your pocket. We think you should consider the Edmunds instant offer due to the no-obligation appraisal and seven-day timeframe to redeem it at a participating dealership.`,
    },
    WHAT_IS_RELATIONSHIP_BETWEEN_EDMUNDS_AND_CARMAX,
  ];
}

export function getSellMyCarInCityStateFaqContent(cityName) {
  return [
    {
      question: `Which is the best site to sell my car in ${cityName}?`,
      answer: `The best site to sell your car in ${cityName} is the one that offers the best balance of convenience and the price you get in return. We happen to think Edmunds' offer strikes that balance the best, with our no-obligation appraisal and a seven-day timeframe to take the offer to a participating dealership.`,
    },
    {
      question: `How can I get the most money for selling my car in ${cityName}?`,
      answer: `Traditionally, a private-party sale will get you the most money for selling a car in ${cityName}, but trade-in prices have hit record highs in recent months, so it's worth getting an appraisal to help decide which route to choose.`,
    },
    {
      question: `What paperwork do I need to sell my car in ${cityName}?`,
      answer: `To sell your car in ${cityName}, you'll typically need this paperwork: your vehicle title, registration, your identification, and the lien holder information if you're still on an active loan. Check with your local dealership before closing the deal to make sure you have everything you need.`,
    },
    {
      question: `How do I sell my car for a good price in ${cityName}?`,
      answer: `The fastest way to sell your car for a good price in ${cityName} is to get an Edmunds instant appraisal. The offer is good for seven days at participating dealerships. You can also get a good price by selling it yourself, but it will take longer and you'll need to be OK dealing with strangers. `,
    },
    WHAT_IS_RELATIONSHIP_BETWEEN_EDMUNDS_AND_CARMAX,
  ];
}

export const isSellCarPage = category => category === SELL_CAR;
